"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cultureContext = exports.CultureProvider = void 0;
var _react = require("react");
const cultureContext = exports.cultureContext = /*#__PURE__*/(0, _react.createContext)({
  culture: undefined,
  financialSet: undefined,
  language: undefined,
  timeZone: undefined
});

/**
 * Stored language, culture settings, financial settings and timezone identification selected from the tenant culture settings.
 * @see {@link CultureContext} for more information about stored value.
 */
const CultureProvider = exports.CultureProvider = cultureContext.Provider;
